import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {CaptchaVerificationResponse} from '../../models/captcha-verification-response.model';


@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  private readonly verifyUrl = 'api/captcha/verify';

  constructor(private readonly http: HttpClient) {}

  verifyToken(captchaToken: string): Observable<CaptchaVerificationResponse> {
    const appToken = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${appToken}`
    });
    return this.http.post<CaptchaVerificationResponse>(this.verifyUrl, { captchaToken }, { headers });
  }
}
